export default {
  ADD_PROVIDERS (state, data) {
    data.forEach(entity => state.providers.push(entity))
  },
  SET_ACCOUNTS (state, data) {
    state.accounts = data.accounts
  },
  SET_BOOKERS (state, data) {
    state.bookers = data.bookers
  },
  SET_DESTINATION_ACCESSORIALS (state, data) {
    state.destinationAccessorials = data
  },
  SET_FINANCE_ITEMS (state, data) {
    state.financeItems = data
  },
  SET_GRAPH (state, data) {
    state.graph = data
  },
  SET_LOCATIONS (state, data) {
    state.locations = data.locations
  },
  SET_ORIGIN_ACCESSORIALS (state, data) {
    state.originAccessorials = data
  },
  SET_PROVIDERS (state, data) {
    state.providers = data
  },
  SET_QUOTES (state, data) {
    state.quotes = data.quotes
  },
  SET_RATE (state, data) {
    state.rate = data
  },
  UPDATE_PREFERENCES (state, data) {
    state.preferences = data
  },
  UPDATE_METRICS (state, data) {
    state.metrics = data
  },
  UPDATE_ALL_SERVICES (state, data) {
    state.allServices = data
  }
}



// WEBPACK FOOTER //
// ./src/modules/quote/store/mutations.js